import { Grid } from '@mui/material';
import { FC, ReactNode } from 'react';
import { useLocation } from '../../hooks/routerCompat';
import { useCrispChat } from '../../../services/crisp/useCrispChat';
import { useTypedSelector } from '../../../store/store';
import { AppRoutes } from '../../constants/routes';
import { Container, CrispIcon, BottomPosition, Hidden } from './Layout.helper';

interface LayoutProps {
  sidebar?: boolean;
  topNav?: boolean;
  children: ReactNode;
}

export const Layout: FC<LayoutProps> = ({ children }) => {
  const isWindow = typeof window !== 'undefined';
  const { openCrispChat } = useCrispChat();
  const location = useLocation();
  const { hideCrispChat } = useTypedSelector((state) => state.ui);

  if (!isWindow) {
    return <div></div>;
  }

  // Determine which styled component to use based on route conditions
  const getCrispComponent = () => {
    if (location.pathname === AppRoutes.Home) {
      return hideCrispChat ? Hidden : BottomPosition;
    }
    if (
      location.pathname.includes('auth') ||
      location.pathname === AppRoutes.ProfileAccount ||
      location.pathname === AppRoutes.video ||
      location.pathname.includes('share') ||
      location.pathname.includes('socialverse')
    ) {
      return BottomPosition;
    }
    return CrispIcon;
  };

  const CrispComponent = getCrispComponent();

  return (
    <Grid item xs={12} component={Container}>
      {children}
      {!hideCrispChat && (
        <CrispComponent onClick={openCrispChat}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          {/* <img src={'/Crisp-chat-2-gray.svg'} alt="crisp" /> */}
        </CrispComponent>
      )}
    </Grid>
  );
};
